import { Typography } from "@earned/core";
import { FC, ReactElement } from "react";
interface ChartTooltipProps {
  children?: ReactElement[] | ReactElement | undefined;
  className?: string;
  title?: ReactElement | string;
}
const ChartTooltip: FC<ChartTooltipProps> = ({
  children,
  className,
  title,
}) => {
  return (
    <div
      className={
        "flex min-h-8 min-w-[250px] flex-col rounded border border-green-50 bg-white p-6 text-label-sm font-medium text-green-5 shadow-sm " +
        (className ? className : "")
      }
    >
      {title && (
        <Typography variant="body" weight="medium" color="primary">
          {title}
        </Typography>
      )}
      {children && title && <div className="mb-5" />}
      {children}
    </div>
  );
};
export default ChartTooltip;
